const work = {
  namespaced: true,
  state: {
    spotStage: null,
    spotStaitstics: null,
  },
  getters: {
    spotStage: state => state.spotStage,
    spotStaitstics: state => state.spotStaitstics,
  },
  mutations: {
    SET_SPOT_STAGE(state, o) {
      state.spotStage = o
    },
    SET_SPOT_STATISTICS(state, o) {
      state.spotStaitstics = o
    },
  },
  actions: {
  },
}

export default work
